const projectMapper = projects => {
  const projectsWithTeam = projects.lead.map(leadItem => ({
    project: leadItem.project,
    team: leadItem.team
  }));
  return projectsWithTeam;
};
export default projectMapper;
